// venus图片缩放剪裁
export function venusParams(imgUrl, width, height) {
    if (!imgUrl)
        return '';
    if (imgUrl.indexOf('http://') > -1) {
        imgUrl = imgUrl.replace('http://', 'https://');
    }
    const param = `@${width}w_${height}h_1e_1c`;
    if (imgUrl.indexOf('.png') !== -1) {
        imgUrl = `${imgUrl.split('.png')[0]}.png`;
    }
    else if (imgUrl.indexOf('.jpg') !== -1) {
        imgUrl = `${imgUrl.split('.jpg')[0]}.jpg`;
    }
    else if (imgUrl.indexOf('.jpeg') !== -1) {
        imgUrl = `${imgUrl.split('.jpeg')[0]}.jpeg`;
    }
    // 处理 . 结尾的图片
    const reg = /\.$/g;
    if (reg.test(imgUrl)) {
        return `${imgUrl}${param}`;
    }
    // 处理 .bmp 结尾的图片
    if (imgUrl.indexOf('.bmp') !== -1) {
        return `${imgUrl}@format=jpeg`;
    }
    // 处理gif
    if (imgUrl.indexOf('.gif') !== -1) {
        imgUrl = `${imgUrl.split('.gif')[0]}.gif`;
        return imgUrl.replace('p0.meituan.net', 'p0.meituan.net/204.212');
    }
    /*if (Agent.android) {
        return imgUrl.search('.webp') !== -1 ? `${imgUrl}${param}` : `${imgUrl}.webp${param}`
    }*/
    return imgUrl.search('@') !== -1 ? imgUrl : `${imgUrl}${param}`;
}
